import ModuleLayout from './Module.vue';

export * from './types';
export default ModuleLayout;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/modules/components/module/index.ts